'use client'
import { GrandSection, GrandText } from 'ui'
import { type FC, useMemo } from 'react'
import type { WidgetBlog } from 'ecosystem'
import { HStack, Text } from '@chakra-ui/react'
import { createCn, lightFormatDate } from 'shared-utils'

interface IBlogInfoProps {
  blogPost: WidgetBlog
}
const cn = createCn('blog-info')

const BlogInfo: FC<IBlogInfoProps> = ({ blogPost }) => {
  const date = useMemo(() => lightFormatDate(blogPost.date), [blogPost.date])

  const authorAndDate = useMemo(() => {
    const arr = []

    if (blogPost.author) {
      arr.push({
        label: 'author',
        value: blogPost.author
      })
    }

    if (date) {
      arr.push({
        label: 'date',
        value: date
      })
    }

    return arr
  }, [blogPost.author, date])

  return (
    <GrandSection
      className={cn()}
      contentContainerProps={{
        py: 1
      }}
      py={0}
      sectionId="info">
      <HStack justify="space-between" w="full" textTransform="uppercase">
        <HStack
          as="p"
          color="text.mild"
          fontSize="sm"
          divider={<Text as="span">{` - `}</Text>}
          display="block"
          w="auto">
          {authorAndDate.map((item) => (
            <Text key={item.label} as="span" className={cn(item.label)}>
              {item.value}
            </Text>
          ))}
        </HStack>

        <GrandText
          className={cn('tag')}
          color="text.mild"
          fontSize="sm"
          fontWeight="bold"
          textAlign="right"
          w="auto">
          {blogPost.tag}
        </GrandText>
      </HStack>
    </GrandSection>
  )
}

export default BlogInfo
